import { degradedStore } from "@/state/degraded/DegradedStore";
import { DegradedModeDTO } from "@/state/degraded/dto/response/degraded.mode.dto";
import Accordions from "@components/core/accordions/Accordions";
import InfoCards from "@components/core/cards/InfoCards";
import PageLayout from "@components/core/layouts/PageLayout";
import Section from "@components/core/section/Section";
import { ROUTES } from "@routes/Routes";
import { requestSearchAlerts } from "@state/alerts/AlertEffects";
import { AlertDetailResponseDto } from "@state/alerts/dto/response/alert.detail.response.dto";
import { authenticationStore } from "@state/auth/AuthStore";
import { requestSearchArticles } from "@state/cms/ArticleEffects";
import { ArticleDetailResponseDto } from "@state/cms/dto/response/article.detail.response.dto";
import { AuthenticationContext } from "@type/core/auth/auth.types";
import { toastError } from "@utils/helpers/toast-helper";
import DashboardSection from "@views/core/extranet/home/sections/DashboardSection";
import NewRequestSection from "@views/core/extranet/home/sections/NewRequestSection";
import { useUnit } from "effector-react";
import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

const HomeScreen: FunctionComponent = () => {
  const { t } = useTranslation();

  const authStore = useUnit<AuthenticationContext | null>(authenticationStore);
  const degradedModeStore = useUnit<DegradedModeDTO | null>(degradedStore);

  const [articles, setArticles] = useState<ArticleDetailResponseDto[]>([]);
  const [alerts, setAlerts] = useState<AlertDetailResponseDto[]>([]);

  useEffect(() => {
    void requestSearchArticles({});
  }, []);

  useEffect(() => {
    return requestSearchArticles.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setArticles(result.data.articleDetails || []);
      } else {
        toastError(t("Erreur lors du chargement des articles"));
      }
    });
  });

  useEffect(() => {
    void requestSearchAlerts({});
  }, []);

  useEffect(() => {
    return requestSearchAlerts.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setAlerts(result.data.alertDetails || []);
      } else {
        toastError(t("Erreur lors du chargement des alertes"));
      }
    });
  });

  if (authStore?.user?.onboarding) {
    return <Navigate to={ROUTES.extranet.onboarding.generate()} />;
  } else {
    return (
      <PageLayout container title={t("home.title")}>
        <>
          <InfoCards
            alerts={alerts}
            selectedOfficeIds={authStore?.selectedOfficeIds || []}
            articles={articles}
          />
          <Section className="pt-15">
            <Accordions
              defaultActiveKey={["new_request"]}
              sections={[
                {
                  key: "new_request",
                  title: t("home.newRequest.title"),
                  content: (
                    <NewRequestSection
                      selectedOfficeIds={authStore?.selectedOfficeIds || []}
                      certificateDegradedMode={
                        degradedModeStore?.certificateDegradedMode
                      }
                      sealDegradedMode={degradedModeStore?.sealDegradedMode}
                      signatureDegradedMode={
                        degradedModeStore?.signatureDegradedMode
                      }
                    />
                  ),
                },
                {
                  key: "dashboard",
                  title: t("home.dashboard.title"),
                  content: <DashboardSection />,
                },
              ]}
            />
          </Section>
        </>
      </PageLayout>
    );
  }
};

export default HomeScreen;
